import { render } from "./UserKickedView.vue?vue&type=template&id=e1b3d3d6&scoped=true"
import script from "./UserKickedView.vue?vue&type=script&lang=js"
export * from "./UserKickedView.vue?vue&type=script&lang=js"

import "./UserKickedView.vue?vue&type=style&index=0&id=e1b3d3d6&scoped=true&lang=css"
import "./UserKickedView.vue?vue&type=style&index=1&id=e1b3d3d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b3d3d6"]])

export default __exports__